module.exports = __webpack_public_path__ + "img/067-kenya.91877f0b.svg";